import { Select } from "antd";
import { observer } from "mobx-react-lite";
import { useIntl } from "react-intl";

type Props = {
  value?: string;
  onChange?: (value?: string) => void;
};

export const TypeSelect = observer<Props>(({ value, onChange }) => {
  const intl = useIntl();
  return (
    <Select
      placeholder={intl.formatMessage({
        defaultMessage: "Select type",
      })}
      options={[
        {
          label: intl.formatMessage({ defaultMessage: "Deposit" }),
          value: "deposit",
        },
        {
          label: intl.formatMessage({ defaultMessage: "Withdraw" }),
          value: "withdraw",
        },
      ]}
      value={value}
      onChange={onChange}
      onClear={onChange}
      allowClear
      style={{ width: "100%" }}
    />
  );
});
